import React, { useEffect, useState } from 'react';
import { Timer } from 'lucide-react';
export function LaunchUrgency() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 2,
    minutes: 45,
    seconds: 0
  });
  useEffect(() => {
    const savedEndTime = sessionStorage.getItem('nerovix_countdown_end');
    let endTime: number;
    if (savedEndTime) {
      endTime = parseInt(savedEndTime, 10);
    } else {
      endTime = new Date().getTime() + 2 * 60 * 60 * 1000 + 45 * 60 * 1000;
      sessionStorage.setItem('nerovix_countdown_end', endTime.toString());
    }
    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = endTime - now;
      if (distance < 0) {
        clearInterval(timer);
        setTimeLeft({
          hours: 0,
          minutes: 0,
          seconds: 0
        });
      } else {
        setTimeLeft({
          hours: Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
          minutes: Math.floor(distance % (1000 * 60 * 60) / (1000 * 60)),
          seconds: Math.floor(distance % (1000 * 60) / 1000)
        });
      }
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section className="bg-pain py-10 md:py-16 border-y border-red-900/40" data-id="element-130">
      <div className="max-w-3xl mx-auto px-4 text-center" data-id="element-131">
        <div className="flex items-center justify-center gap-2 mb-4" data-id="element-132">
          <Timer className="w-6 h-6 text-soft-gold animate-pulse" data-id="element-133" />
          <h2 className="text-soft-gold text-xl md:text-2xl font-bold tracking-wider" data-id="element-134">
            ⏰ LAUNCH PRICE — CLOSES IN:
          </h2>
        </div>

        <div className="flex justify-center gap-4 mb-6" data-id="element-135">
          <div className="bg-red-600 text-white rounded-lg p-4 min-w-[80px] shadow-lg" data-id="element-136">
            <span className="text-4xl md:text-5xl font-bold font-mono" data-id="element-137">
              {String(timeLeft.hours).padStart(2, '0')}
            </span>
            <span className="block text-xs uppercase mt-1 opacity-90" data-id="element-138">
              Hours
            </span>
          </div>
          <div className="text-red-600 text-4xl md:text-5xl font-bold py-2" data-id="element-139">
            :
          </div>
          <div className="bg-red-600 text-white rounded-lg p-4 min-w-[80px] shadow-lg" data-id="element-140">
            <span className="text-4xl md:text-5xl font-bold font-mono" data-id="element-141">
              {String(timeLeft.minutes).padStart(2, '0')}
            </span>
            <span className="block text-xs uppercase mt-1 opacity-90" data-id="element-142">
              Mins
            </span>
          </div>
          <div className="text-red-600 text-4xl md:text-5xl font-bold py-2" data-id="element-143">
            :
          </div>
          <div className="bg-red-600 text-white rounded-lg p-4 min-w-[80px] shadow-lg" data-id="element-144">
            <span className="text-4xl md:text-5xl font-bold font-mono" data-id="element-145">
              {String(timeLeft.seconds).padStart(2, '0')}
            </span>
            <span className="block text-xs uppercase mt-1 opacity-90" data-id="element-146">
              Secs
            </span>
          </div>
        </div>

        <p className="text-white text-sm md:text-base mb-8" data-id="element-147">
          Warning: Price increases to NZD $67 when timer hits zero.
        </p>

        <div className="max-w-md mx-auto" data-id="element-148">
          <div className="flex justify-between text-soft-gold text-xs font-bold mb-2" data-id="element-149">
            <span data-id="element-150">Available Copies Claimed</span>
            <span data-id="element-151">68%</span>
          </div>
          <div className="w-full bg-[#333333] rounded-full h-3 mb-2 overflow-hidden" data-id="element-152">
            <div className="bg-soft-gold h-3 rounded-full" style={{
            width: '68%'
          }} data-id="element-153"></div>
          </div>
          <p className="text-soft-gold text-xs" data-id="element-154">High demand in NZ/AU region</p>
        </div>
      </div>
    </section>;
}